<template>
  <div class="nav-wrapper">
    <div class="nav-container container-fixed">
      <!-- Logo 区域 -->
      <router-link to="/" class="logo">
        <img src="../assets/images/logo.png" alt="" />
      </router-link>

      <!-- 菜单项 -->
      <div class="menu-list">
        <router-link
          v-for="(item, index) in navlist"
          :key="index"
          :to="item.path"
          class="menu-item"
          :class="{ active: isMenuActive(item.path) }"
        >
          {{ item.title }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Nav",
  data() {
    return {
      navlist: [
        { title: "首页", path: "/" },
        { title: "广西招投标公告", path: "/invitation" },
        { title: "西部CA办理", path: "/camodule" },
        { title: "服务项目", path: "/projectservices" },
        { title: "新闻资讯", path: "/news" },
        { title: "关于我们", path: "/about" },
      ],
    };
  },
  methods: {
    isMenuActive(path) {
      const currentPath = this.$route.path;
      if (path === "/") {
        return currentPath === "/";
      }

      // 招投标公告及其详情
      if (path === "/invitation") {
        const invitationPaths = [
          "/invitation",
          "/cailist",
          "/caitable",
          "/listinfo",
          "/tableinfo",
        ];
        return invitationPaths.some((p) => currentPath.startsWith(p));
      }

      // 西部CA及其详情
      if (path === "/camodule") {
        const caPaths = ["/camodule", "/imgecourse"];
        return caPaths.some((p) => currentPath.startsWith(p));
      }

      // 新闻资讯及其详情
      if (path === "/news") {
        const newsPaths = [
          "/news",
          "/AllNews",
          "/GroupNews",
          "/TradeNews",
          "/MediaCoverage",
          "/newsdetal",
        ];
        return newsPaths.some((p) => currentPath.startsWith(p));
      }

      return currentPath.startsWith(path);
    },
  },
};
</script>

<style scoped lang="less">
@import "../assets/styles/variables.less";

.nav-wrapper {
  width: 100%;
  height: 80px; // 稍微增加高度更显大气
  background-color: #ffffff;
  box-shadow: 0 1px 0 0 @border-color;
  position: sticky;
  top: 0;
  z-index: 1000;
}

.nav-container {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo {
  height: 48px;
  display: flex;
  align-items: center;

  img {
    height: 100%;
    width: auto;
    object-fit: contain;
  }
}

.menu-list {
  display: flex;
  gap: 32px;
  height: 100%;
}

.menu-item {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  color: @text-main;
  position: relative;
  height: 100%;
  padding: 0 4px;
  transition: all 0.3s ease;

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0;
    height: 3px;
    background-color: @primary-color;
    transition: all 0.3s ease;
  }

  &:hover {
    color: @primary-color;
  }

  &.active {
    color: @primary-color;
    &::after {
      width: 100%;
    }
  }
}
</style>
